/**
 * Store permettant de gérer les toggle view chrono ou classique d'affichage dans les différents menus
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ReduxRefresh: false,
};

export const ReduxRefreshSlice = createSlice({
  name: "ReduxRefresh",
  initialState,
  reducers: {
    forceRefreshData: (state, action) => {
      state.ReduxRefresh = !state.ReduxRefresh;
    },
  },
});

export const { forceRefreshData } = ReduxRefreshSlice.actions;

export default ReduxRefreshSlice.reducer;
